export default __webpack_public_path__ + "static/media/logo.29e23cd2.png";